import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-success alert-dismissible",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Successfully ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "aria-label": "Close"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "card d-none d-md-block" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "table card-table" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Product Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Date")
  ])
], -1)
const _hoisted_10 = { class: "table-border-bottom-0" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_13 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_16 = { class: "mobile-view d-block d-md-none" }
const _hoisted_17 = {
  key: 0,
  class: "card"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "spinner-border text-primary",
      role: "status"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ])
  ])
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Quantity: ")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "badge bg-success"
}
const _hoisted_27 = {
  key: 1,
  class: "badge bg-danger"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.successReport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: dataItem.id
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", null, _toDisplayString(dataItem.product.name), 1),
                _createElementVNode("td", null, _toDisplayString(dataItem.type), 1),
                _createElementVNode("td", null, [
                  (dataItem.quantity)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        (dataItem.quantity >= 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(dataItem.quantity) + " " + _toDisplayString(dataItem.product.unit), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(dataItem.quantity) + " " + _toDisplayString(dataItem.product.unit), 1))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "00"))
                ]),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDateTime(dataItem.created_at)), 1),
                _hoisted_15
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card mb-4",
          key: dataItem.id
        }, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("strong", null, " Name: " + _toDisplayString(dataItem.product.name), 1),
            _hoisted_21,
            _createElementVNode("small", null, "Type: " + _toDisplayString(dataItem.type), 1),
            _hoisted_22,
            _hoisted_23,
            _createElementVNode("small", null, [
              _hoisted_24,
              (dataItem.quantity)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    (dataItem.quantity >= 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(dataItem.quantity) + " " + _toDisplayString(dataItem.product.unit), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(dataItem.quantity) + " " + _toDisplayString(dataItem.product.unit), 1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, "00"))
            ]),
            _hoisted_29,
            _createElementVNode("small", null, "Time:" + _toDisplayString(_ctx.formatDateTime(dataItem.created_at)), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}